/**
 * SeparatorDotIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SeparatorDotIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SeparatorDotIcon = makeIcon('SeparatorDotIcon', SeparatorDotIconSvg)
